<div class="modal-header align-items-start pb-2">
    <div>
        <h2 class="modal-title fs-5">
            {{ 'sftpconnection_testserverfiles_title' | translate: 'online' : 'export' }}
        </h2>
        <div class="text-secondary small">{{ sftpConnection.name }}</div>
    </div>
    <button
        type="button"
        class="btn-close"
        [attr.aria-label]="'savedexport_export_modal_close' | translate: 'online' : 'export'"
        (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
        <p class="text-secondary mb-0">
            {{ 'sftpconnection_testserverfiles_description' | translate: 'online' : 'export' }}
        </p>
        <div class="d-flex gap-2">
            <button
                type="button"
                class="btn btn-outline-primary d-inline-flex align-items-center gap-2 text-nowrap"
                (click)="resetFilters()">
                <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
                {{ 'savedexport_overview_filter_reset' | translate: 'online' : 'export' }}
            </button>
            <button
                type="button"
                class="btn btn-outline-primary d-inline-flex align-items-center gap-2 text-nowrap"
                [disabled]="state().status === 'loading'"
                (click)="refresh()">
                <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
                {{ 'sftpconnection_testserverfiles_refresh' | translate: 'online' : 'export' }}
            </button>
        </div>
    </div>

    @if (state(); as current) {
        @if (current.status === 'unavailable') {
            <div class="alert alert-warning mb-0">
                {{ 'sftpconnection_testserverfiles_unavailable' | translate: 'online' : 'export' }}
            </div>
        } @else if (failureMessage(); as message) {
            <div class="alert alert-danger mb-0">
                {{
                    'sftpconnection_testserverfiles_failed'
                        | translate: 'online' : 'export' : [message]
                }}
            </div>
        } @else {
            <app-export-table
                [columns]="columns"
                [currentSorting]="sorting()"
                [loading]="current.status === 'loading'"
                (sort)="onSort($event)">
                <tr appExportTableFilters [formGroup]="filters">
                    <td class="align-top">
                        <input
                            type="search"
                            class="form-control sftp-test-server-files-search"
                            formControlName="search"
                            [placeholder]="
                                'sftpconnection_testserverfiles_search_placeholder'
                                    | translate: 'online' : 'export'
                            " />
                    </td>
                    <td class="align-top"></td>
                    <td class="align-top"></td>
                    <td class="align-top">
                        <app-input-date-group
                            class="d-block sftp-test-server-files-date"
                            formControlName="modifiedOn" />
                    </td>
                    <td class="align-top"></td>
                </tr>
                @for (file of files(); track file.folder + '/' + file.fileName) {
                    <tr class="text-nowrap">
                        <td class="align-middle">
                            <div class="text-truncate" [title]="file.folder">{{ file.folder }}</div>
                        </td>
                        <td class="align-middle fw-bold">
                            <div class="text-truncate" [title]="file.fileName">
                                {{ file.fileName }}
                            </div>
                        </td>
                        <td class="align-middle">{{ file.sizeBytes | appformatbytes }}</td>
                        <td class="align-middle">{{ file.modifiedAt | appdatetime }}</td>
                        <td class="align-middle text-end">
                            <app-action-button
                                [label]="{key: 'titles_download', module: 'systems'}"
                                variant="outline-primary"
                                size="sm"
                                icon="bi-download"
                                [busy]="downloadingFile() === file"
                                [disabled]="downloadingFile() !== null"
                                (run)="download(file)" />
                        </td>
                    </tr>
                } @empty {
                    <tr>
                        <td [attr.colspan]="columns.length">
                            @if (fileCount() === 0) {
                                {{
                                    'sftpconnection_testserverfiles_empty'
                                        | translate: 'online' : 'export'
                                }}
                            } @else {
                                {{
                                    'sftpconnection_testserverfiles_no_matches'
                                        | translate: 'online' : 'export'
                                }}
                            }
                        </td>
                    </tr>
                }
            </app-export-table>
        }
    }
</div>
